/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
"use strict"

import angular from "angular"

angular
  .module("uCountitUiApp")

  .directive("exportConfig", () => ({
    restrict: "E",
    templateUrl: "app/admin/company/export/export-config.html",
    controller: "ExportConfigCtrl",

    scope: {
      isOpen: "=",
      selectedItem: "=",
      onApply: "=",
    },
  }))
